import { faCheckCircle, faEdit, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useCallback, useState } from 'react'
import FormInputSwitch from './generated_form/FormInputSwitch'
import IInput from './generated_form/IInput'

interface IToggledInputProps {
  input: IInput
  onConfirm: (inputId: string, value: number | string) => void
  disable?: boolean
}

const ToggledInput: React.FC<IToggledInputProps> = ({ input, onConfirm, disable }) => {
  const [isEdit, setIsEdit] = useState<boolean>(false)
  const [value, setValue] = useState<number | string | undefined>(input.defaultValue)

  const handleChange = useCallback((inputId: string, value_: string | number | null) => {
    setValue(value_ || '')
  }, [])

  const handleEdit = useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    setIsEdit(true)
  }, [])

  const handleConfirmByEnter = useCallback(() => {
    setIsEdit(false)
    if (value || (!input.required && typeof value === 'string' && value.length === 0)) {
      onConfirm(input.id, value)
    }
  }, [input, value, onConfirm])

  const handleConfirm = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault()
      setIsEdit(false)
      if (value || (!input.required && typeof value === 'string' && value.length === 0)) {
        onConfirm(input.id, value)
      }
    },
    [input, value, onConfirm]
  )

  const handleCancel = useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    setIsEdit(false)
  }, [])

  return (
    <>
      {isEdit ? (
        <>
          <FormInputSwitch
            input={input}
            onChange={handleChange}
            onEntered={handleConfirmByEnter}
          />

          <a href='/#/' onClick={handleConfirm} className='my-link'>
            <FontAwesomeIcon icon={faCheckCircle} size='lg' color='var(--color-green)' />
          </a>
          <a href='/#/' onClick={handleCancel} className='my-link'>
            <FontAwesomeIcon icon={faTimesCircle} size='lg' color='var(--color-red)' />
          </a>
        </>
      ) : (
        <>
          <div>{input.defaultValue || 'Не указанно'}</div>
          {!disable && (
            <a href='/#/' onClick={handleEdit} className='my-link'>
              <FontAwesomeIcon icon={faEdit} size='lg' />
            </a>
          )}
        </>
      )}
    </>
  )
}
export default ToggledInput
